import { CancelTokenSource } from 'axios'
import Agent from '../api/Agent'

class UserRegistrationService {
  getCurrentUserProfile = async (source: CancelTokenSource) => {
    return await Agent.UserRegistrations.getCurrentUserProfile(source)
  }

  getRegisterUserViewModel = async (source: CancelTokenSource) => {
    return await Agent.UserRegistrations.getRegisterUserViewModel(source)
  }
}

export default new UserRegistrationService()
